import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalHeader } from 'reactstrap';
import { IModalProps } from '../../../types';
import { UpdateForm } from '../../FilteredIps/UpdateForm';

export const UpdateFilteredIp: FunctionComponent<IModalProps> = (props) => {
  const { t } = useTranslation();

  const { hideModal, data } = props;

  return (
    <>
      <ModalHeader className="font-montserrat m-0 border-0">
        {t('updateFilteredIp.header', { id: data.id })}
      </ModalHeader>
      <ModalBody>
        <UpdateForm filteredIp={data} onCancel={hideModal} />
      </ModalBody>
    </>
  );
};
